// @mui material components
import {
  CircularProgress,
  Backdrop,
  Grid,
  ButtonGroup,
  Button,
  Box,
  SwipeableDrawer,
  styled,
  Typography,
  Skeleton,
  CssBaseline,
  Paper,
  Link,
  Dialog,
  AppBar,
  Toolbar,
  IconButton,
  Slide,
} from "@mui/material";
import { Global } from "@emotion/react";
import { grey } from "@mui/material/colors";
import DownloadIcon from "@mui/icons-material/Download";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
// import CommonPage from "interpretation-module";
// Interpretation dashboards components
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import { Document, Page, pdfjs } from "react-pdf";
import { useEffect, useRef, useState } from "react";
import { Panel, PanelGroup } from "react-resizable-panels";
import PanelResizeHandle from "./hooks/ResizeHandler";
import PagingControl from "./PagingControl";
import panelStyles from "./panel-style.module.css";
import dayjs from "dayjs";
import { useNavigate, useLocation, useParams } from "react-router-dom";
// Data
import CustomReportInputForm from "./report-input-form/custom-report-input-form";
import { downloadFromURI, base64ToBlob, viewBlobFile } from "./Utils";
import useResponsive from "./hooks/useResponsive";
import { useGetEcgData, useSetInterpretation } from "../../api/report";

import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers";
import PdfPreview from "../../components/PdfPreview";
import { toast } from 'sonner';
import moment from "moment";
import SVGViewer from "../../components/SVGViewer";
import {
  ANALYTICS_EVENTS,
  logAnalyticsEvent,
  INTERPRETATION_SAVE_SOURCE,
} from "../../analytics";

// Use local worker (no CDN needed)
pdfjs.GlobalWorkerOptions.workerSrc = new URL(
  "pdfjs-dist/build/pdf.worker.min.mjs",
  import.meta.url
).toString();

const drawerBleeding = 54;
const Root = styled("div")(({ theme }) => ({
  height: "100%",
  //   backgroundColor:
  //     theme?.palette?.mode === 'light' ? grey[100] : theme?.palette?.background?.default,
}));

const StyledBox = styled("div")(({ theme }) => ({
  // backgroundColor: theme?.palette?.mode === 'light' ? '#fff' : grey[800],
}));

const Puller = styled("div")(({ theme }) => ({
  width: 30,
  height: 6,
  // backgroundColor: theme?.palette?.mode === 'light' ? grey[300] : grey[900],
  borderRadius: 3,
  position: "absolute",
  top: 8,
  left: "calc(50% - 15px)",
}));

const props = { window: () => Window };

function Interpret({ id }) {
  const navigate = useNavigate();
  const isLg = useResponsive("up", "md");
  const isMd = useResponsive("between", "sm", "md");
  
  // edit pdf
  const documentRef = useRef(null);
  const { ecgData, isLoading } = useGetEcgData(id);
  const [allFilesData, setAllFilesData] = useState(() =>
    ecgData ? [ecgData] : [],
  );
  const [renderedFileIndex, setRenderedFile] = useState(0);
  const [pdf, setPdf] = useState(() => ecgData?.ReportPdf || null);
  const [leadsData, setLeadsData] = useState(() => ecgData?.svgGraph || null);
  const [importError, setImportError] = useState("");
  const [pageNum, setPageNum] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [renderAllPages, setRenderAllPages] = useState(false);
  const [pdfScale, setPdfScale] = useState(isLg || isMd ? 1 : 0.5);
  const [loading, setLoading] = useState(false);
  const [loadingdata, setLoadingdata] = useState(() => isLoading);

  ////////////////////////////////////////////////////////////

  useEffect(() => {
    if (!isLoading) {
      try {
        const fetchedPdfData = ecgData?.ReportPdf;
        setLoadingdata(false);
        if (!ecgData || !fetchedPdfData) {
          return setImportError("Unable to fetch report. Please try again.");
        }
        const URL = `data:application/pdf;base64,${fetchedPdfData}`;
        setPdf(URL);
        setLeadsData(ecgData?.svgGraph);
        setAllFilesData([ecgData]);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }
  }, [isLoading]);

  /////////////////////////////////////////////////

  //Handle form submit
  const handleReportInputFormSubmit = async (event, formInput) => {
    event.preventDefault();
    const wasAlreadyInterpreted = !!allFilesData[renderedFileIndex]
      ?.interpretation_data?.completed_at;
    const dataToUpdate = {
      ...formInput,
      name: `${formInput["first_name"]}${formInput["last_name"]}`,
      completed_at: allFilesData[renderedFileIndex]?.completed_at || new Date(),
    };
    const bodyData = {
      id: allFilesData[renderedFileIndex]?.id,
      interpretationFormData: dataToUpdate,
    };
    const updateInterpretationData = async () => {
      try {
        const response = await useSetInterpretation({
          bodyData,
        });
        setLoadingdata(false);
        if (response && response?.status === 200 && response?.data) {
          const reportdata = response?.data;
          const fetchedPdfData = reportdata?.ReportPdf;
          delete reportdata.ReportPdf;
          const URL = `data:application/pdf;base64,${fetchedPdfData}`;
          setPdf(URL);
          toast.success(response.message);

          logAnalyticsEvent(
            ANALYTICS_EVENTS.IN_HOUSE_INTERPRETATION_SAVED_SUCCESSFULLY,
            {
              source: wasAlreadyInterpreted
                ? INTERPRETATION_SAVE_SOURCE.EDIT
                : INTERPRETATION_SAVE_SOURCE.INTERPRET,
            }
          );

          if (reportdata?.interpretation_data)
            setAllFilesData((previousStatus) => [
              {
                ...previousStatus[0],
                interpretation_data: reportdata?.interpretation_data,
              },
            ]);
        } else {
          toast.error(response.message);
        }
      } catch (error) {
        console.error("Error updating interpretation data:", error);
      }
    };
    await updateInterpretationData();
  };

  function downloadURI(uri) {
    const reportdata = allFilesData[0];
    const fileName = `${reportdata?.user_data?.first_name}${
      reportdata?.user_data?.last_name
        ? "-" + reportdata?.user_data?.last_name
        : ""
    }-${dayjs(reportdata?.report_timestamp).format("DD-MM-YYYY-HH-mm")}${
      reportdata?.interpretation_data?.report_status
        ? `-${reportdata?.interpretation_data?.report_status}`
        : ""
    }.pdf`;
    //  const fileName = "123.pdf";
    downloadFromURI(uri, fileName);
    toast.success("pdf downloading successfully");
  }

  const handleBackClick = (e) => {
    setPdf(null);
    setTotalPages(0);
    setPageNum(0);
    setAllFilesData([]);
    setImportError("");
    setLoading(false);
    setRenderedFile(0);
    navigate(-1);
  };

  // const handleZoom = (scale) => {
  //   setPdfScale(scale <= 1 ? (isLg ? 1 : 0.5) : scale);
  // };

  const { window } = props;
  const [open, setOpen] = useState(false);

  const toggleDrawer = (newOpen) => () => {
    setOpen(newOpen);
  };

  const container =
    typeof window !== "undefined" ? () => document.body : undefined;

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Root>
        <CssBaseline />
        <Global
          styles={{
            ".MuiDrawer-root > .MuiPaper-root": {
              height: `calc(90% - ${drawerBleeding}px)`,
              overflow: "visible",
            },
          }}
        />

        <Grid mt={1}>
          {/* <CommonPage /> */}
          {loadingdata ? (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                marginTop: "300px",
              }}
            >
              <CircularProgress />
            </Box>
          ) : (
            <>
              <Grid item xs={12} lg={12}>
                {pdf ? (
                  <PanelGroup
                    direction="horizontal"
                    className={panelStyles.PanelGroup}
                  >
                    <Panel
                      defaultSize={isLg ? 55 : 100}
                      minSize={isLg ? 48 : 100}
                      maxSize={isLg ? 60 : 100}
                      className={panelStyles.PanelPdf}
                    >
                      <div>
                        <div
                          className={panelStyles.viewerControls}
                        >
                          <ButtonGroup
                            className={panelStyles.viewerActionGroup}
                            variant="outlined"
                            aria-label="outlined button group"
                          >
                            <Button
                              className={panelStyles.backButton}
                              size="small"
                              onClick={handleBackClick}
                              startIcon={<ArrowBackIcon />}
                            >
                              Back
                            </Button>
                            {pdf ? (
                              (allFilesData || []).length &&
                              allFilesData[renderedFileIndex]["id"] ? (
                                <>
                                  <Button
                                    className={panelStyles.downloadButton}
                                    size="small"
                                    onClick={() => {
                                      downloadURI(pdf);
                                    }}
                                    startIcon={<DownloadIcon />}
                                  >
                                    Download
                                  </Button>
                                  
                                </>
                              ) : (
                                ""
                              )
                            ) : null}
                          </ButtonGroup>
                        </div>
                        <StyledBox
                          className={panelStyles.workspaceScroller}
                        >
                        <SVGViewer svgGraph={leadsData} documentRef={documentRef} />
                          <Box
                            className={panelStyles.patientContent}
                          >
                            <Typography className={panelStyles.sectionTitle}>Patient details</Typography>
                            <div
                              className={panelStyles.infoSection}
                            >
                              <div className={panelStyles.infoGrid}>
                                {[
                                  {
                                    label: "NAME",
                                    value:
                                      ecgData?.user_data?.first_name +
                                      " " +
                                      ecgData?.user_data?.last_name,
                                  },
                                  {
                                    label: "PATIENT ID",
                                    value:
                                      ecgData?.user_data?.patient_id || "--",
                                  },
                                  {
                                    label: "AGE",
                                    value: `${ecgData?.user_data?.age} Years`,
                                  },
                                  {
                                    label: "GENDER",
                                    value: ecgData?.user_data?.gender,
                                  },
                                  {
                                    label: "TEST",
                                    value:
                                      ecgData?.report_type ==
                                      "REPORT_TWELVE_LEAD"
                                        ? "12 Lead ECG"
                                        : "6 Lead ECG",
                                  },
                                  {
                                    label: "CENTER",
                                    value: ecgData?.center_details?.centerName,
                                  },
                                ].map((item, i) => (
                                  <div
                                    key={i}
                                    className={panelStyles.infoItem}
                                  >
                                    <span className={panelStyles.infoLabel}>{item.label}</span>
                                    <span className={panelStyles.infoValue}>{item.value || "--"}</span>
                                  </div>
                                ))}
                              </div>
                            </div>
                            <Typography className={panelStyles.sectionTitle}>Patient vitals</Typography>
                            <div
                              className={panelStyles.infoSection}
                            >
                              <div className={panelStyles.infoGrid}>
          {[
            {
              label: "HEIGHT",
              value: ecgData?.body_vitals?.height?.value != null
                ? `${ecgData.body_vitals.height.value} ${ecgData.body_vitals.height.unit ?? ""}`
                : "-"
            },
            {
              label: "WEIGHT",
              value: ecgData?.body_vitals?.weight?.value != null
                ? `${ecgData.body_vitals.weight.value} ${ecgData.body_vitals.weight.unit ?? ""}`
                : "-"
            },
            {
              label: "SPO2",
              value: ecgData?.body_vitals?.spo2?.value != null
                ? `${ecgData.body_vitals.spo2.value} ${ecgData.body_vitals.spo2.unit ?? ""}`
                : "-"
            },
            {
              label: "BP",
              value:
                ecgData?.body_vitals?.blood_pressure?.systolic != null &&
                  ecgData?.body_vitals?.blood_pressure?.diastolic != null
                  ? `${ecgData.body_vitals.blood_pressure.systolic}/${ecgData.body_vitals.blood_pressure.diastolic} ${ecgData.body_vitals.blood_pressure.unit ?? ""}`
                  : "-"
            },
            {
              label: "TEMP",
              value: ecgData?.body_vitals?.temperature?.value != null
                ? `${ecgData.body_vitals.temperature.value} ${ecgData.body_vitals.temperature.unit ?? ""}`
                : "-"
            }
          ].map((item, i) => (
            <div key={i} className={panelStyles.infoItem}>
              <span className={panelStyles.infoLabel}>{item.label}</span>
              <span className={panelStyles.infoValue}>{item.value}</span>
            </div>
          ))}
        </div>
                            </div>
                            <Typography className={panelStyles.sectionTitle}>Collection details</Typography>
                            {(() => {
                              let deviceName = "--";
                              try {
                                const parsedMeta = JSON.parse(
                                  ecgData?.meta_data || "{}"
                                );
                                deviceName = (
                                  parsedMeta.device_name || "--"
                                ).replace(/_/g, " ");
                              } catch (e) {
                                deviceName = "--";
                              }

                              const collectedBy =
                                ecgData?.assignee_details?.firstName &&
                                ecgData?.assignee_details?.lastName
                                  ? `${ecgData?.assignee_details.firstName} ${ecgData?.assignee_details.lastName}`
                                  : "--";

                              const collectedOn =
                                ecgData?.report_timestamp_readable
                                  ? moment(
                                      ecgData?.report_timestamp_readable
                                    ).format("lll")
                                  : "";

                              const displayData = [
                                { label: "DEVICE", value: deviceName },
                                { label: "COLLECTED BY", value: collectedBy },
                                { label: "COLLECTED ON", value: collectedOn },
                              ];

                              return (
                                <div className={panelStyles.infoSection}>
                                  <div className={panelStyles.infoGrid}>
                                    {displayData?.map((item, i) => (
                                      <div
                                        key={i}
                                        className={panelStyles.infoItem}
                                      >
                                        <span className={panelStyles.infoLabel}>{item.label}</span>
                                        <span className={panelStyles.infoValue}>{item.value}</span>
                                      </div>
                                    ))}
                                  </div>
                                </div>
                              );
                            })()}

                            <div>
                              <Typography className={panelStyles.sectionTitle}>Symptoms</Typography>
                              <div className={panelStyles.symptoms}>
                                {ecgData?.symptoms &&
                                ecgData.symptoms.length > 0 ? (
                                  ecgData.symptoms.map((symptom, index) => (
                                    <span
                                      key={index}
                                      className={panelStyles.symptomChip}
                                    >
                                      {symptom}
                                    </span>
                                  ))
                                ) : (
                                  <Typography variant="body2" color="text.secondary">No symptoms recorded</Typography>
                                )}
                              </div>
                            </div>

                            <div>
                              <Typography className={panelStyles.sectionTitle}>Medical history notes</Typography>
                            <div className={panelStyles.infoSection}>
                              <p className={panelStyles.notes}>
                                {ecgData?.medical_history_notes ||
                                  "No medical history notes provided."}
                              </p>
                            </div>
                            </div>
                          </Box>
                        </StyledBox>
                      </div>
                    </Panel>
                    {isLg ? (
                      <>
                        <PanelResizeHandle />
                        <Panel
                          defaultSize={30}
                          minSize={20}
                          className={panelStyles.Panel}
                        >
                          {allFilesData.length ? (
                            <div>
                              <CustomReportInputForm
                                formKey={renderedFileIndex}
                                subsDetails={
                                  allFilesData[renderedFileIndex]
                                    .subscription_details
                                }
                                businessName={
                                  allFilesData[renderedFileIndex].business_name
                                }
                                displayData={{
                                  report_timestamp:
                                    allFilesData[renderedFileIndex]
                                      ?.report_timestamp,
                                }}
                                reportData={allFilesData[renderedFileIndex]}
                                inputData={{
                                  ...allFilesData[renderedFileIndex]?.user_data,
                                  ...allFilesData[renderedFileIndex]
                                    ?.interpretation_data,
                                  interpretation_request_status:
                                    allFilesData[renderedFileIndex]
                                      ?.interpretation_request_status,
                                }}
                                handleReportInputFormSubmit={
                                  handleReportInputFormSubmit
                                }
                              ></CustomReportInputForm>
                            </div>
                          ) : (
                            ""
                          )}
                        </Panel>
                      </>
                    ) : (
                      <SwipeableDrawer
                        container={container}
                        anchor="bottom"
                        open={open}
                        onClose={toggleDrawer(false)}
                        onOpen={toggleDrawer(true)}
                        swipeAreaWidth={drawerBleeding}
                        disableSwipeToOpen={false}
                        ModalProps={{
                          keepMounted: true,
                        }}
                      >
                        <StyledBox
                          sx={{
                            position: "absolute",
                            top: -drawerBleeding,
                            borderTopLeftRadius: 8,
                            borderTopRightRadius: 8,
                            visibility: "visible",
                            backgroundColor: "#cccccc",
                            right: 0,
                            left: 0,
                          }}
                        >
                          <Puller />
                          <Typography
                            sx={{
                              pt: 3,
                              pb: 1,
                              px: 2,
                              color: "text.secondary",
                            }}
                          >
                            {allFilesData[renderedFileIndex]
                              ?.interpretation_data?.completed_at ? (
                              <Typography variant="body2" textAlign="center">
                                {`By: `}
                                <b>
                                  {
                                    allFilesData[renderedFileIndex]
                                      ?.interpretation_data?.interpreter_details
                                      ?.name
                                  }
                                </b>
                                <Typography variant="body2" display="inline">
                                  {` at `}
                                  <b>
                                    {dayjs(
                                      parseInt(
                                        allFilesData[renderedFileIndex]
                                          ?.interpretation_data?.completed_at
                                      )
                                    ).format("DD MMM hh:mm A")}
                                  </b>
                                </Typography>
                              </Typography>
                            ) : (
                              <Typography variant="body2" textAlign="center">
                                Click to interpret
                              </Typography>
                            )}
                          </Typography>
                        </StyledBox>
                        <StyledBox
                          sx={{
                            px: 2,
                            py: 2,
                            height: "100%",
                            overflow: "auto",
                          }}
                        >
                          {allFilesData.length ? (
                            <CustomReportInputForm
                              formKey={renderedFileIndex}
                              displayData={{
                                report_timestamp:
                                  allFilesData[renderedFileIndex]
                                    ?.report_timestamp,
                              }}
                              reportData={allFilesData[renderedFileIndex]}
                              inputData={{
                                ...allFilesData[renderedFileIndex]?.user_data,
                                ...allFilesData[renderedFileIndex]
                                  ?.interpretation_data,
                                interpretation_request_status:
                                  allFilesData[renderedFileIndex]
                                    ?.interpretation_request_status,
                              }}
                              handleReportInputFormSubmit={
                                handleReportInputFormSubmit
                              }
                            />
                          ) : null}
                        </StyledBox>
                      </SwipeableDrawer>
                    )}
                  </PanelGroup>
                ) : importError ? (
                  <div className={panelStyles.invalidReportBlock}></div>
                ) : (
                  ""
                )}
              </Grid>
            </>
          )}
          <Backdrop
            // sx={{ color: "#fff", zIndex: (theme) => theme?.zIndex?.drawer + 1 }}
            open={loading}
          >
            <CircularProgress color="inherit" />
          </Backdrop>
        </Grid>
      </Root>
    </LocalizationProvider>
  );
}

export default Interpret;
